import React from 'react';
import {Body, Button, Headline} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import Modal from '@/components/modal';
import styles from './ConfirmModal.module.scss';

interface ConfirmModalProps {
  open: boolean;
  title: string;
  body: string;
  confirmLabel: string;
  cancelLabel?: string;
  confirmAppearance?: 'brand' | 'neutral' | 'danger' | 'overlay';
  isLoading?: boolean;
  isCancelDisabled?: boolean;
  isConfirmDisabled?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  children?: React.ReactNode;
}

export default function ConfirmModal({
  open,
  title,
  body,
  confirmLabel,
  cancelLabel = 'Cancel',
  confirmAppearance = 'neutral',
  isLoading = false,
  isCancelDisabled = false,
  isConfirmDisabled = false,
  onConfirm,
  onCancel,
  children,
}: ConfirmModalProps) {
  return (
    <Modal
      open={open}
      onClose={isLoading ? undefined : onCancel}
      size="small"
      contentClassName={styles.modalContent}
    >
      <div className={styles.modalInner}>
        <Headline size="md" className={styles.modalTitle}>
          {translate(title)}
        </Headline>
        <Body size="md" className={styles.modalBody}>
          {translate(body)}
        </Body>
        {children}
        <div className={styles.modalActions}>
          <Button
            appearance="neutral"
            mode="tinted"
            size="large"
            disabled={isCancelDisabled}
            onClick={onCancel}
          >
            {translate(cancelLabel)}
          </Button>
          <Button
            appearance={confirmAppearance}
            mode="filled"
            size="large"
            isLoading={isLoading}
            disabled={isLoading || isConfirmDisabled}
            onClick={onConfirm}
          >
            {translate(confirmLabel)}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
